import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 16px;
  right: 16px;
  padding: 0; /* não use padding grande, isso cria área clicável em cima do header */
  z-index: 9999;

  display: flex;
  flex-direction: column;
  gap: 10px;

  /* não bloquear clique no header/hamburguer */
  pointer-events: none;

  /* mas cada toast continua clicável */
  > div {
    pointer-events: auto;
  }

  @media (max-width: 860px) {
    top: 76px; /* desce um pouco pra não ficar colado no header */
    right: 12px;
    left: 12px; /* ocupa largura no mobile */
    align-items: stretch;
  }
`;
